<template>
  <div class="index">
    <div id="okdata">
      <!-- <header>
        <div class="container">
          <div class="datah_left"><img src="../assets/data_logo.png" /></div>
          <div class="datah_right">
            <nav>

              <el-menu :default-active="activeIndex2"
                       class="el-menu-demo"
                       mode="horizontal"
                       @select="handleSelect"
                       background-color="#050C16"
                       text-color="#fff"
                       active-text-color="#FFF">
                <el-menu-item index="1"><router-link to="/index">数据总览</router-link></el-menu-item>
                <el-menu-item index="2"><router-link to="/number">数据总览</router-link></el-menu-item> -->
      <!-- <el-submenu index="1">
                  <template slot="title">
                    <router-link to="/number">社区贡献</router-link>
                  </template> -->
      <!-- <el-menu-item index="2-1"> <router-link to="/number">个人贡献</router-link> </el-menu-item>
                  <el-menu-item index="2-2"> <router-link to="/number">社区贡献</router-link> </el-menu-item> -->

      <!-- </el-submenu> -->
      <!-- <el-menu-item index="3" disabled>消息中心</el-menu-item> -->
      <!-- </el-menu>
            </nav>
          </div>
        </div>
      </header> -->
      <!-- 中间内容 -->
      <section id="liuxing">
        <div id="liuxing2">
          <span class="span"></span>
          <span class="span"></span>
          <span class="span"></span>
          <span class="span"></span>
          <span class="span"></span>
          <span class="span"></span>
          <span class="span"></span>
          <span class="span"></span>
          <span class="span"></span>
          <span class="span"></span>
        </div>
        <div id="okdata_c">

          <div class="container" id="okdata_contant">
            <div class="okdata_c_left">
              <ul>
                <li class="okdata-deploy">
                  <h3>{{ $t('okmain.deploy') }}</h3>
                  <h1 id="sz0">{{ deployTotal }}</h1>
                </li>
                <li>
                  <h3>{{ $t('okmain.user') }}</h3>
                  <h1 id="sz1">{{ memberTotal }}</h1>
                </li>
                <li @click="handleHref('https://cla.openkylin.top/')" style="cursor: pointer;">
                  <h3>{{ $t('okmain.contributors') }}</h3>
                  <h1 id="sz2">{{ message.contributor }}</h1>
                </li>
                <li @click="handleHref('https://www.openkylin.top/community/partner-cn.html')" style="cursor: pointer;">
                  <h3>{{ $t('okmain.member') }}</h3>
                  <h1 id="sz3">{{ message.member }}</h1>
                </li>
                <li @click="handleHref('https://www.openkylin.top/dynamic/higher_education_zone-cn.html')" style="cursor: pointer;">
                  <h3>{{ $t('okmain.university') }}</h3>
                  <h1 id="sz9">{{ universityTotal }}</h1>
                </li>
                <li @click="handleHref('https://www.openkylin.top/sig/siglist-cn.html')" style="cursor: pointer;">
                  <h3>{{ $t('okmain.sig') }}</h3>
                  <h1 id="sz4">{{ message.sig }}</h1>
                </li>
                <li @click="handleHref('https://www.openkylin.top/community/okug_intro.html')" style="cursor: pointer;">
                  <h3>{{ $t('okmain.userGroup') }}</h3>
                  <h1 id="sz10">{{ userGroupTotal }}</h1>
                </li>
              </ul>
            </div>
            <div class="okdata_c_center">
            </div>
            <div class="okdata_c_right" @click="handleHref('https://gitee.com/openkylin')" style="cursor: pointer;">
              <ul>
                <li>
                  <h3>{{ $t('okmain.repositories') }} </h3>
                  <h1 id="sz5">{{ message.warehouse }}</h1>
                </li>
                <li>
                  <h3>{{ $t('okmain.commits') }}</h3>
                  <h1>
                    <div id="sz6" style="float:left">{{ message.commit }}</div>K
                  </h1>
                </li>
                <li>
                  <h3>{{ $t('okmain.pr') }}</h3>
                  <h1 id="sz7">{{ message.pr }}</h1>
                </li>
                <li>
                  <h3>{{ $t('okmain.issues') }}</h3>
                  <h1 id="sz8">{{ message.issue }}</h1>
                </li>
              </ul>
            </div>
          </div>
          <div id="okdata_bottom" class="container">
            <h6 id="time1">{{ $t('okmain.f_updatetime') }}：{{ getCurrentTime() }}&nbsp;&nbsp;{{ $t('okmain.f_frequency')
              }}：3
              {{ $t('okmain.f_times') }}</h6>
            <!-- <h6 class="more">查看更多数据</h6>
				<h6 class="more"><a href="viewlist.html"><img src="../assets/data_more.png" ></a></h6> -->
          </div>
        </div>


      </section>

    </div>


  </div>
</template>

<script>


import AppHeader from "./Header.vue"
import AppFooter from "./footer.vue"
export default {
  name: 'Index',
  data() {
    return {
      message: {},
      memberTotal: 0,
      deployBase: 24724820,
      universityTotal: 148,
      userGroupTotal: 57
    }
  },
  computed: {
    deployTotal: function () {
      return this.deployBase + Number(this.memberTotal || 0);
    }
  },
  components: {
    AppHeader,
    AppFooter
  },
  beforeRouteEnter: (to, from, next) => {

    next(vm => {
      vm.getData();
      vm.getMember();
      vm.getUserGroup();
      vm.animateNumber('#sz9', vm.universityTotal, 1200);
    })
  },
  methods: {
    handleHref: function (url) {
      window.open(url);
    },
    animateNumber: function (selector, value, duration) {
      $(selector).prop('Counter', 0).animate({
        Counter: value
      }, {
        duration: duration,
        easing: 'swing',
        step: function (now) {
          $(this).text(Math.ceil(now).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
        }
      });
    },
    getData: function () {
      this.axios({
        method: 'get',
        url: "https://dashboard-api.openkylin.top/api/data/overview",
      }).then(repos => {
        //  console.log(repos.data);
        this.message = repos.data.data;
        this.message.member = this.message.member + 13;
        // this.message.commit = this.message.commit;
        // this.message.contributor = this.message.contributor;
        // this.message.warehouse = this.message.warehouse;
        // this.message.pr = this.message.pr;
        // this.message.issue = this.message.issue;

        //接入数字滚动特效
        this.animateNumber('#sz2', this.message.contributor, 1200);
        this.animateNumber('#sz3', this.message.member, 1200);
        this.animateNumber('#sz4', this.message.sig, 1300);
        this.animateNumber('#sz5', this.message.warehouse, 1100);
        $('#sz6').prop('Counter', 0).animate({
          Counter: this.message.commit
        }, {
          duration: 1500,
          easing: 'swing',
          step: function (now) {
            $(this).text((now / 1000).toFixed(1));
          }
        });
        this.animateNumber('#sz7', this.message.pr, 1200);
        this.animateNumber('#sz8', this.message.issue, 1500);


      }).catch(function (error) {
        console.log(error);
      });
    },
    getMember: function () {
      this.axios({
        method: 'get',
        url: "https://www.openkylin.top/datatransfer.php?act=total",
      }).then(repos => {
        this.memberTotal = repos.data;
        // 部署量 = 基准值 + 当前用户数，与用户数同步滚动
        this.animateNumber('#sz0', this.deployTotal, 1500);
        this.animateNumber('#sz1', this.memberTotal, 1300);
      }).catch(function (error) {
        console.log(error);
      });

    },
    getUserGroup: function () {
      this.axios({
        method: 'get',
        url: "https://id.openkylin.top/prod-api/user-group?index=1&size=1&sort=order_index",
      }).then(repos => {
        const total = repos.data && repos.data.total;
        this.userGroupTotal = total != null && total !== '' ? Number(total) : 57;
        this.animateNumber('#sz10', this.userGroupTotal, 1200);
      }).catch(() => {
        this.userGroupTotal = 57;
        this.animateNumber('#sz10', this.userGroupTotal, 1200);
      });
    },
    getCurrentTime: function () {
      var timeStamp = Date.now();
      let y = new Date(timeStamp).getFullYear().toString()
      let M = new Date(timeStamp).getMonth() + 1 < 10 ? '0' + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1
      let d = new Date(timeStamp).getDate() < 10 ? '0' + new Date(timeStamp).getDate() : new Date(timeStamp).getDate()
      var nowTime = y + '-' + M + '-' + d + ''
      return nowTime;

    }
  }

}







</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#liuxing {
  /* z-index:200; */
  position: relative;
  top: 0;
  left: 0;
  /* min-height: 100vh;  */
  width: 100%;
  height: 100%;
  overflow: hidden;

}

#liuxing2 {
  width: 100%;
  background: url(https://www.openkylin.top/public/images/openkylin/data_bg.png);
  background-position-x: center;
  background-size: cover;
  animation: animateBg 15s linear infinite;
  position: absolute;
  height: 100%;
  z-index: 200;


}

#okdata_c {
  position: relative;
  z-index: 201;
  width: 100%;
}

#okdata_contant {
  display: table;
}

@keyframes animateBg {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }
}

span {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 4px;
  height: 4px;
  background: #FFFFFF;
  border-radius: 50%;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.1), 0 0 0 8px rgba(255, 255, 255, 0.1), 0 0 20px rgba(255, 255, 255, 1);
  animation: animate 3s linear infinite;
}

@keyframes animate {
  0% {
    transform: rotate(315deg) translateX(-100px);
    opacity: 1;
  }

  70% {
    opacity: 1;
  }

  100% {
    transform: rotate(315deg) translateX(-1000px);
    opacity: 0;
  }
}

span::before {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 1px;
  background: linear-gradient(90deg, #fff, transparent);
}

span:nth-child(1) {
  top: 0;
  right: 0;
  left: initial;
  animation-delay: 0;
  animation-duration: 1s;
}

span:nth-child(2) {
  top: 0;
  right: 80px;
  left: initial;
  animation-delay: 0.2s;
  animation-duration: 1s;
}

span:nth-child(3) {
  top: 80px;
  right: 0px;
  left: initial;
  animation-delay: 0.4s;
  animation-duration: 2s;
}

span:nth-child(4) {
  top: 0;
  right: 180px;
  left: initial;
  animation-delay: 0.6s;
  animation-duration: 1.5s;
}

span:nth-child(5) {
  top: 0;
  right: 400px;
  left: initial;
  animation-delay: 0.8s;
  animation-duration: 2.5s;
}

span:nth-child(6) {
  top: 0;
  right: 600px;
  left: initial;
  animation-delay: 1s;
  animation-duration: 3s;
}

span:nth-child(7) {
  top: 300px;
  right: 0px;
  left: initial;
  animation-delay: 1.2s;
  animation-duration: 1.75s;
}

span:nth-child(8) {
  top: 0;
  right: 700px;
  left: initial;
  animation-delay: 1.4s;
  animation-duration: 1.25s;
}

span:nth-child(9) {
  top: 0;
  right: 900px;
  left: initial;
  animation-delay: 1.6s;
  animation-duration: 1s;
}

span:nth-child(10) {
  top: 0;
  right: 110px;
  left: initial;
  animation-delay: 2.2s;
  animation-duration: 1.54s;
}


@media (max-width:540px) {
  #liuxing {
    height: auto;
    overflow: visible;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue